export const RecursiveMenuView = {
    onRender() {
        setTimeout(() => {
            if (this.model.reconstructTraitHierarchy) {
                this.model.reconstructTraitHierarchy();
            }
            this.model.updateMenuView();
        }, 100);
    },

    init() {
        this.listenTo(this.model, 'change:attributes', () => {
            this.model.updateMenuView();
        });
    }
};